"use client";

import { useState } from "react";
import { createPortal } from "react-dom";
import { CookiePreferencesModal } from "./CookiePreferencesModal";

// The banner disappears once answered, so this is how a visitor changes or withdraws consent later:
// withdrawing has to be as easy as giving it (GDPR art. 7.3, AEPD cookie guidance).
export function BotonPreferenciasCookies({ className }: { className?: string }) {
    const [abierto, setAbierto] = useState(false);

    return (
        <>
            <button type="button" onClick={() => setAbierto(true)} className={className}>
                Configurar cookies
            </button>
            {/* Portal: inside the footer the modal inherits its z-10 stacking context and the fixed
                site header covers the top of the dialog. */}
            {abierto && createPortal(<CookiePreferencesModal onClose={() => setAbierto(false)} />, document.body)}
        </>
    );
}
